module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))])])], 1)]), _vm._v(" "), (_vm.serial.startsWith('KH2')) ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CalRemain),
      expression: "CalRemain"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "name": "KHRemain",
      "type": "text"
    },
    domProps: {
      "value": (_vm.CalRemain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CalRemain = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))])])])]) : _vm._e(), _vm._v(" "), (_vm.serial.startsWith('KH2')) ? _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][4]))]), _vm._v(" "), _c('div', {
    staticClass: "px-2 row align-self-center",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Calday),
      expression: "Calday"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "name": "KH_specification",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Calday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Calday = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][5]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][6]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mlspec),
      expression: "mlspec"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "name": "mlspec",
      "type": "text"
    },
    domProps: {
      "value": (_vm.mlspec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mlspec = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("ml")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 pb-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-3 mb-1 justify-content-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [(_vm.name !== 'khacra') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "name": "KH_settings_button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEGUlEQVR4nO2ZXYhVVRTHf0oppi+CTnObHkrHkAShRI3A3rKc8d2HhHp0sjDHDHpVH6SaStEoXxp6LVD8igInKPMbHzQ/qic1MCEtdfyc6siS/4bl4Z5zzzn3zL1HmD9s7r17r7X2/u+99t5r7QtjGMMYimIpsA8YBqI2l+saS29eEhsqMPgooazPsxKmcBt4F6jRftSAtRpTlHVlhiRsJKqG9zQ2c7OGuC7hTqqHTo3tWhbh4ItVRZR1fEWJPA0sBzYB3wJngEvATeAG8Kfq9gKfAq8BT1WFyEydIqeaOIV+AdYBM9pB5EXN7H9O/i6wX8RsZV4Cul17t+qWS2a/dEK72doFvNAKIjZrO5zM//q8CEwpYG+KdL2tCNguVy2dyDjgbXfLjwCDwDPAOdW9UqDjxWo7J1uDsh1u87fUdylEbNa+cfVD6jTgfdXvTLD3E/BjQttO6ZqNALP9g+vv69hqFyZyWL9vAWuA8TH56TqZLpMfV6RrNjzGq69b6vtQGUSO6rcdnR0JOguBBfl53NezUg8d6jPSGJLGl4i4oM3WCUemFbHX9FifnWVtdpudk6o/wujjqPo6WccLmj5+zeAx4GCK7gFt7vg+youD6qujHSGK4bc8YXZBRK0gsla6e3jIiUxVgGi39CweYiKGL6X/IaODoVYRmS/9v4BJGeSfBFa60H9YJYT8b0omwEKWVa1KrI7IxhsN7opNLrZKKxYZf5X3DiuDyOuycTzlgeNqbKAW1g8Aq1UGVOdTBdPpaSWRicoOI7mah7nKv2q7o1VJm+kasFmykXT7WkXE8IHs2ED9SoQZPg88F9N5DJinYt89ngcuODI9o03kEWAZ8L3sWDZpeMK503n9jmOe69++x9HlyPzT6KWnGSJzXUxm5TvXts25U3wlshJB9SFF/pxRIPKyyx9+1xFpM4iOz5E6rlaEiGGLy1RDH6UQ6XYPe58Aj8baV7rTqVYCkS631xI3ftREsZmqh71qt+OUEoiESNvkdpOAoiQsL5+QYPNXyXxEeUQGXOKVSqRMXJPN/gZy7+QgsqbRO3A7iEzWU1CkciPDy2NbiJxNca1nY0+up4A5GWwWcq2flcIWxZ6Ezb4o9tfeoFYnC8Jmt2fWzETSHtmyIOn4naxH7OEGkXKh4zf4c5nPPv5CtADQY7bcKw+2uguxXqhzH/skZPl3mfjChSgWABbFfBeifJYm2Cuh2/rPLpFxTtQU6EUK/BJDiwYr+4ds/A08TgOsb/KG92XIvaj3uFzkQoa7Ir4SgYTZWEJG9MrNQgzVTPE5dp8jc1dhTdqqd2lPBHcy3RVUBD3OzcJpZsfpx0pz+/X9QCzVNXd6lYphGrDRpbBpZUSHRRX/Mn/Adfp0aZ6WK1ux7xbZmhuVdeBUH/cAv69V+xjnvZQAAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796c548e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KH_cal_solution.vue
// module id = 528
// module chunks = 0